import React from 'react'

const QuestionIcon = ({ height, width }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            style={{
                fill: 'currentColor',
                height: height,
                overflow: 'hidden',
                verticalAlign: 'middle',
                width: width,
            }}
            viewBox="0 0 36.5 36.5"
        >
            <circle style={{ fill: '#ccc' }} cx="18.25" cy="18.25" r="18.21" />
            <path style={{ strokeWidth: 0, fill: '#fff' }} d="M15.27,23.74l-.04-.97c-.11-1.91.53-3.86,2.21-5.89,1.2-1.43,2.17-2.63,2.17-3.9s-.86-2.18-2.74-2.25c-1.24,0-2.74.45-3.71,1.13l-1.28-4.09c1.35-.79,3.6-1.54,6.26-1.54,4.95,0,7.2,2.74,7.2,5.85,0,2.85-1.76,4.73-3.19,6.3-1.39,1.54-1.95,3-1.91,4.69v.67h-4.99ZM14.3,28.92c0-1.99,1.39-3.41,3.34-3.41s3.34,1.43,3.38,3.41c0,1.95-1.35,3.41-3.38,3.41s-3.34-1.46-3.34-3.41Z" />
        </svg>
    )
}

export default QuestionIcon
